import * as patches from './patches';

/**
 * Given adjacent patch pair p1,p2, commute them to create a new
 * adjacent pair p2',p1'
 * @param {array} p1 JSON Patch
 * @param {array} p2 JSON Patch
 * @returns {array<array>} pair [commutedRight, commutedLeft]
 */
export function commute(p1, p2)
{
    return p1.reduceRight(function(a, p1)
    {
        const commuted = commuteOneFully(p1, a[1]);
        a[0].unshift(commuted[0]);
        const b = [a[0], commuted[1]];
        return b;
    }, [[], p2]);
}

function commuteOneFully(op, p)
{
    return p.reduce(function(a, p)
    {
        const commuted = commuteOne(a[0], p);
        a[0] = commuted[1];
        a[1].push(commuted[0]);
        return a;
    }, [op, []]);
}

/**
 * Commute left and right and return only the newly commuted left, throwing
 * away the newly commuted right.
 * @param p1
 * @param p2
 * @returns {*}
 */
export function commuteRtL(p1, p2)
{
    return p2
        .map(change2 =>
            p1.reduceRight((change2c, change1) =>
                    commuteOne(change1, change2c)[0],
                change2
            )
        )
        .filter(change => change.op != 'skip');
}

function commuteOne(p1, p2)
{
    if( p1.op == 'skip' || p2.op == 'skip' )
        return [p2, p1];

    const patch = patches[p1.op];
    if( patch === void 0 || typeof patch.commute !== 'function' )
    {
        throw new TypeError('patches cannot be commuted');
    }

    return patch.commute(p1, p2);
}
